module.exports = __webpack_public_path__ + "static/media/LK_Log out.70ade64e.svg";